import { DropdownSelectionProps } from '@shared/components/DropdownButton/DropdownSelection';
import { SelectProps } from '@shared/components/Select/Select';
import SelectGroup from '@shared/components/Select/SelectGroup';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

type OptionsDropdownProps = {
  options: DropdownSelectionProps[];
  title?: string;
  disabledTitle?: string;
  className?: string;
  selectClassName?: string;
} & Pick<SelectProps, 'dropdownContainerClass' | 'dropDownClassName'>;

const OptionsDropdown = ({
  title,
  options,
  disabledTitle,
  className,
  selectClassName,
  dropdownContainerClass,
  dropDownClassName,
}: OptionsDropdownProps) => {
  const { t } = useTranslation();
  const selectedOption = options.find(({ isSelected }) => isSelected);
  const hasOptions = !!options.length;

  const optionTitle = selectedOption ? selectedOption.title : t('please_select');

  return (
    <SelectGroup disabled={!hasOptions} className={cx('min-w-0', className)} size="sm">
      {title && <SelectGroup.Label>{title}</SelectGroup.Label>}
      <SelectGroup.Select
        options={options}
        dropdownContainerClass={cx('!min-w-0', dropdownContainerClass)}
        dropDownClassName={dropDownClassName}
        className={selectClassName}
      >
        {hasOptions ? optionTitle : disabledTitle}
      </SelectGroup.Select>
    </SelectGroup>
  );
};

export default OptionsDropdown;
